<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="el-main-content">
        <div
            class="el-grid-card"
            style="width: 100%; padding: 10px; background-color: #323b49"
        >
            <div class="el-grid-card__header" style="color: white; padding: 0">
                {{ $t('form.label.containersAndPermissions') }}
            </div>
        </div>

        <div
            class="el-grid-card"
            style="
                width: 100%;
                padding: 10px 10px 30px 10px;
                background-color: #323b49;
            "
        >
            <el-row>
                <h4 style="color: #fff">{{ $t('form.label.containers') }}</h4>
            </el-row>
            <el-row>
                <v-btn
                    @click.stop="showPermissionsSelectContainerList"
                    dark
                    class="container-btn-toggle"
                    color="primary"
                    style="border-radius: 0px !important"
                    >{{ $t('form.label.addNewContainer') }}
                </v-btn>
            </el-row>
            <el-row
                class="flex justify-between items-center filter-block"
                style="margin-top: 10px"
            >
                <v-btn-toggle
                    class="top-data-btn"
                    v-model="activeContainer"
                    style="
                        width: 100%;
                        flex-wrap: wrap;
                        background-color: #313b49;
                        box-shadow: none !important;
                    "
                >
                    <span
                        v-for="(
                            container, index
                        ) in currentSelectedContainerList"
                        :key="index"
                        style="
                            background-color: #20252c;
                            border-right: 1px solid white;
                        "
                    >
                        <v-btn
                            flat
                            style="border-color: #20252c !important"
                            class="container-btn-toggle"
                            color="dark"
                            @click.stop="
                                selectAsCurrentContainerAndViewPermissions(
                                    container
                                )
                            "
                        >
                            {{ container.Description }}
                        </v-btn>
                        <span
                            @click.stop="deleteContainer(container, index)"
                            style="
                                color: white;
                                font-weight: bold;
                                cursor: pointer;
                                margin-right: 2px;
                            "
                            class="el-icon-close"
                        ></span>
                    </span>
                </v-btn-toggle>
            </el-row>
        </div>

        <div
            v-if="currentSelectedContainerList.length !== 0"
            class="el-grid-card"
            style="width: 100%; padding: 10px; background-color: #323b49"
        >
            <el-row style="margin-bottom: 20px; padding: 20px">
                <el-col :span="24">
                    <el-row>
                        <v-radio-group
                            style="margin-bottom: -15px"
                            v-model="showDetailedModeSelectedValue"
                            row
                        >
                            <v-radio
                                color="primary"
                                :label="$t('form.label.viewSimpleMode')"
                                value="SIMPLE_VIEW"
                            ></v-radio>
                            <v-radio
                                color="primary"
                                :label="$t('form.label.viewDetailedMode')"
                                value="DETAILED_VIEW"
                            ></v-radio>
                        </v-radio-group>
                        <span
                            v-if="containsDisabledPermissions"
                            style="color: rgb(53, 200, 181); font-size: 12px"
                            >{{
                                $t('message.warning.disabledPermissions')
                            }}</span
                        >
                    </el-row>
                    <el-row></el-row>
                    <v-expansion-panel expand v-if="showDetailedMode">
                        <v-expansion-panel-content
                            v-for="(permission, i) in permissionsList"
                            :key="i"
                            :value="
                                permissionsToggleHandling(
                                    permission,
                                    checkedPermissions
                                )
                            "
                            style="background-color: #28303b"
                        >
                            <div slot="header">
                                <span style="color: #33c8b4; font-size: 16px">{{
                                    permission.Category
                                        ? permission.Category
                                        : 'General'
                                }}</span>
                            </div>
                            <div
                                style="
                                    padding-left: 25px;
                                    padding-top: 5px;
                                    padding-bottom: 5px;
                                "
                            >
                                <el-col
                                    :span="8"
                                    v-for="i in permission.Values"
                                    :key="i"
                                >
                                    <v-checkbox
                                        :label="i"
                                        :value="i"
                                        color="primary"
                                        hide-details
                                        :disabled="
                                            disbaledDetailedModePermissions(i)
                                        "
                                        :id="i"
                                        v-model="checkedPermissions"
                                        true-value="true"
                                        false-value="false"
                                        v-on:change="
                                            onDetailedPermChange($event, i)
                                        "
                                    >
                                    </v-checkbox>
                                </el-col>
                            </div>
                        </v-expansion-panel-content>
                    </v-expansion-panel>

                    <el-row
                        v-if="!showDetailedMode"
                        style="
                            background-color: #27303b;
                            padding-left: 15px;
                            padding-top: 10px;
                        "
                    >
                        <div
                            class="el-form-card__element-wrapper"
                            style="margin-left: -32px"
                        >
                            <div
                                class="
                                    el-checkbox-list
                                    el-checkbox-list--bottom-gap
                                    el-checkbox-list--top-gap
                                "
                            >
                                <v-checkbox
                                    :label="
                                        $t('form.label.permission.login-access')
                                    "
                                    :disabled="
                                        !(
                                            _.difference(
                                                simplePermConstArr2[0],
                                                loggedInUserContainerPermissionsForCurrentMatch
                                            ).length === 0
                                        )
                                    "
                                    v-model="simplePermModels[0]"
                                    true-value="true"
                                    false-value="false"
                                    v-on:change="
                                        onSimplePermChange(
                                            simplePermModels[0],
                                            simplePermConstArr[0]
                                        )
                                    "
                                    :value="simplePermConstArr[0]"
                                    color="primary"
                                    hide-details
                                >
                                </v-checkbox>
                                <v-checkbox
                                    :label="
                                        $t(
                                            'form.label.allowUserManageSchedules'
                                        )
                                    "
                                    :disabled="
                                        !(
                                            _.difference(
                                                simplePermConstArr2[1],
                                                loggedInUserContainerPermissionsForCurrentMatch
                                            ).length === 0
                                        )
                                    "
                                    v-model="simplePermModels[1]"
                                    true-value="true"
                                    false-value="false"
                                    v-on:change="
                                        onSimplePermChange(
                                            simplePermModels[1],
                                            simplePermConstArr[1]
                                        )
                                    "
                                    :value="simplePermConstArr[1]"
                                    color="primary"
                                    hide-details
                                >
                                </v-checkbox>
                                <v-checkbox
                                    :label="$t('form.label.permission.manage')"
                                    :disabled="
                                        !(
                                            _.difference(
                                                simplePermConstArr2[2],
                                                loggedInUserContainerPermissionsForCurrentMatch
                                            ).length === 0
                                        )
                                    "
                                    v-model="simplePermModels[2]"
                                    true-value="true"
                                    false-value="false"
                                    v-on:change="
                                        onSimplePermChange(
                                            simplePermModels[2],
                                            simplePermConstArr[2]
                                        )
                                    "
                                    :value="simplePermConstArr[2]"
                                    color="primary"
                                    hide-details
                                >
                                </v-checkbox>
                                <v-checkbox
                                    :label="
                                        $t(
                                            'form.label.permission.supplier-manage'
                                        )
                                    "
                                    :disabled="
                                        !(
                                            _.difference(
                                                simplePermConstArr2[3],
                                                loggedInUserContainerPermissionsForCurrentMatch
                                            ).length === 0
                                        )
                                    "
                                    v-model="simplePermModels[3]"
                                    true-value="true"
                                    false-value="false"
                                    v-on:change="
                                        onSimplePermChange(
                                            simplePermModels[3],
                                            simplePermConstArr[3]
                                        )
                                    "
                                    :value="simplePermConstArr[3]"
                                    color="primary"
                                    hide-details
                                >
                                </v-checkbox>
                                <v-checkbox
                                    :label="$t('form.label.permission.access')"
                                    :disabled="
                                        !(
                                            _.difference(
                                                simplePermConstArr2[4],
                                                loggedInUserContainerPermissionsForCurrentMatch
                                            ).length === 0
                                        )
                                    "
                                    v-model="simplePermModels[4]"
                                    true-value="true"
                                    false-value="false"
                                    v-on:change="
                                        onSimplePermChange(
                                            simplePermModels[4],
                                            simplePermConstArr[4]
                                        )
                                    "
                                    :value="simplePermConstArr[4]"
                                    color="primary"
                                    hide-details
                                >
                                </v-checkbox>
                                <v-checkbox
                                    :label="$t('form.label.permission.blc')"
                                    :disabled="
                                        !(
                                            _.difference(
                                                simplePermConstArr2[5],
                                                loggedInUserContainerPermissionsForCurrentMatch
                                            ).length === 0
                                        )
                                    "
                                    v-model="simplePermModels[5]"
                                    true-value="true"
                                    false-value="false"
                                    v-on:change="
                                        onSimplePermChange(
                                            simplePermModels[5],
                                            simplePermConstArr[5]
                                        )
                                    "
                                    :value="simplePermConstArr[5]"
                                    color="primary"
                                    hide-details
                                >
                                </v-checkbox>
                                <v-checkbox
                                    :label="
                                        $t(
                                            'form.label.permission.unloading-areas-use'
                                        )
                                    "
                                    :disabled="
                                        !(
                                            _.difference(
                                                simplePermConstArr2[6],
                                                loggedInUserContainerPermissionsForCurrentMatch
                                            ).length === 0
                                        )
                                    "
                                    v-model="simplePermModels[6]"
                                    true-value="true"
                                    false-value="false"
                                    v-on:change="
                                        onSimplePermChange(
                                            simplePermModels[6],
                                            simplePermConstArr[6]
                                        )
                                    "
                                    :value="simplePermConstArr[6]"
                                    color="primary"
                                    hide-details
                                >
                                </v-checkbox>
                                <v-checkbox
                                    :label="
                                        $t(
                                            'form.label.permission.unloading-areas-manage'
                                        )
                                    "
                                    :disabled="
                                        !(
                                            _.difference(
                                                simplePermConstArr2[7],
                                                loggedInUserContainerPermissionsForCurrentMatch
                                            ).length === 0
                                        )
                                    "
                                    v-model="simplePermModels[7]"
                                    true-value="true"
                                    false-value="false"
                                    v-on:change="
                                        onSimplePermChange(
                                            simplePermModels[7],
                                            simplePermConstArr[7]
                                        )
                                    "
                                    :value="simplePermConstArr[7]"
                                    color="primary"
                                    hide-details
                                >
                                </v-checkbox>
                                <v-checkbox
                                    :label="
                                        $t('form.label.superUserPermissions')
                                    "
                                    :disabled="
                                        !(
                                            _.difference(
                                                simplePermConstArr2[8],
                                                loggedInUserContainerPermissionsForCurrentMatch
                                            ).length === 0
                                        )
                                    "
                                    v-model="simplePermModels[8]"
                                    true-value="true"
                                    false-value="false"
                                    v-on:change="
                                        onSimplePermChange(
                                            simplePermModels[8],
                                            simplePermConstArr[8]
                                        )
                                    "
                                    :value="simplePermConstArr[8]"
                                    color="primary"
                                    hide-details
                                >
                                </v-checkbox>
                                <v-checkbox
                                    :label="$t('form.label.mobileCalendar')"
                                    :disabled="
                                        !loggedInUserContainerPermissionsForCurrentMatch.includes(
                                            simplePermConstArr2[9][0]
                                        )
                                    "
                                    v-model="simplePermModels[9]"
                                    true-value="true"
                                    false-value="false"
                                    v-on:change="
                                        onSimplePermChange(
                                            simplePermModels[9],
                                            simplePermConstArr[9]
                                        )
                                    "
                                    :value="simplePermConstArr[9]"
                                    color="primary"
                                    hide-details
                                >
                                </v-checkbox>
                            </div>
                        </div>
                    </el-row>
                </el-col>
            </el-row>
        </div>

        <div>
            <el-dialog :visible.sync="showContainerTreeSelect" width="30%">
                <span slot="title">
                    <div class="flex justify-between">
                        <span>{{ $t('title.chooseContainer') }}</span>
                    </div>
                </span>
                <div style="height: 350px">
                    <treeselect
                        ref="containerTreeSelect"
                        :alwaysOpen="true"
                        v-model="selectedContainers"
                        value-format="object"
                        class="top-multiselect"
                        :multiple="true"
                        :flat="isFlat"
                        :backspace-removes="false"
                        :default-expand-level="1"
                        :value-consists-of="treeValueConsistsOf"
                        :limit="treeLimit"
                        :before-clear-all="handleBeforeClearAll"
                        :placeholder="$t('form.label.selectContainers')"
                        :options="selectedContainerTree"
                        :normalizer="normalizer"
                    ></treeselect>
                </div>
                <el-row>
                    <el-col :span="24">
                        <v-btn
                            style="float: right; z-index: 999; margin-top: 25px"
                            round
                            color="primary"
                            dark
                            @click.stop="onContainerSelect()"
                        >
                            {{ $t('modal.button.done') }}
                        </v-btn>
                    </el-col>
                </el-row>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import Treeselect from '@riophae/vue-treeselect'
import StcDialog from '../Dialog'

Vue.prototype._ = _

export default {
    name: 'containers-and-permissions',
    props: {
        containers: Array,
        permissionsList: Array,
    },
    data() {
        return {
            activeContainer: 0,
            showContainerTreeSelect: false,
            selectedContainers: [],
            currentSelectedContainerList: [], // NEW
            currentSelectedContainer: '',
            currentSelectedContainerPermissions: [],
            finalSelectedDetailedPermissionsList: [],
            checkedPermissions: [],
            simplePermissions: [],
            permissionSelectDoneObj: {
                permissions: [],
                unloadingAreas: [],
            },
            loggedInUserContainerWithPermissions: [],
            loggedInUserContainerPermissionsForCurrentMatch: [],
            treeValueConsistsOf: 'ALL',
            includeSubContainers: false,
            isFlat: true,
            normalizer(node) {
                let data = {
                    id: node.ContainerID,
                    label: node.Description,
                }

                if (node.Children && node.Children.length) {
                    return {
                        ...data,
                        children: node.Children,
                    }
                }

                return data
            },
            treeLimit: 3,
            permissions: [
                'SUPPLIER_VIEW',
                'UNLOADINGAREA_READ',
                'CHECKPOINT_READ',
                'UTIL_READ',
                'CONTAINER_READ',
                'USER_READ',
                'SCHEDULETEMPLATE_READ',
                'ACTOR_READ',
            ],
            isPermissionDisabled: true,
            showDetailedMode: false,
            showDetailedModeSelectedValue: 'SIMPLE_VIEW',
            simplePermConstArr: [
                'CONTAINER_READ,USER_READ',
                'SCHEDULETEMPLATE_WRITE,SCHEDULETEMPLATE_DELETE,SCHEDULETEMPLATE_READ,CONTAINER_READ',
                'ACTOR_WRITE,ACTOR_DELETE,ACTOR_READ,CONTAINER_READ,USER_READ,SCHEDULETEMPLATE_READ,JOB_READ,CHECKPOINT_READ,SUPPLIER_VIEW,UNLOADINGAREA_READ',
                'SUPPLIER_MANAGE,SUPPLIER_VIEW,CONTAINER_READ',
                'USER_WRITE,USER_DELETE,SCHEDULETEMPLATE_READ,USER_READ,ACTOR_WRITE,ACTOR_DELETE,ACTOR_READ,CHECKPOINT_READ,JOB_READ,CONTAINER_READ',
                'BLC_READ,BLC_WRITE,BLC_REPORT_READ,VEHICLE_READ,VEHICLE_DELETE,VEHICLE_WRITE,ACTOR_WRITE,ACTOR_DELETE,ACTOR_READ,CHECKPOINT_READ,CONTAINER_READ,JOB_READ,SCHEDULETEMPLATE_DELETE,SCHEDULETEMPLATE_READ,SCHEDULETEMPLATE_WRITE,UNLOADINGAREA_GRANT,UNLOADINGAREA_READ,UNLOADINGAREA_WRITE,USER_WRITE,USER_DELETE,USER_READ,SUPPLIER_MANAGE,SUPPLIER_VIEW,UTIL_READ',
                'ACTOR_WRITE,ACTOR_READ,ACTOR_DELETE,UNLOADINGAREA_READ,CHECKPOINT_READ,SCHEDULETEMPLATE_READ',
                'CHECKPOINT_READ,CONTAINER_READ,UNLOADINGAREA_READ,UNLOADINGAREA_WRITE',
                'ACTOR_WRITE,ACTOR_DELETE,ACTOR_READ,CHECKPOINT_READ,CONTAINER_READ,JOB_READ,SCHEDULETEMPLATE_DELETE,SCHEDULETEMPLATE_READ,SCHEDULETEMPLATE_WRITE,UNLOADINGAREA_GRANT,UNLOADINGAREA_READ,USER_WRITE,USER_DELETE,USER_READ,SUPPLIER_MANAGE,SUPPLIER_VIEW,SUPER_USER,UTIL_READ',
                'MOBILE_CALENDAR,STC_MOBILE_NOTIFICATIONS',
            ],
            simplePermConstArr2: [
                ['CONTAINER_READ', 'USER_READ'],
                [
                    'SCHEDULETEMPLATE_WRITE',
                    'SCHEDULETEMPLATE_DELETE',
                    'SCHEDULETEMPLATE_READ',
                    'CONTAINER_READ',
                ],
                [
                    'ACTOR_WRITE',
                    'ACTOR_DELETE',
                    'ACTOR_READ',
                    'CONTAINER_READ',
                    'USER_READ',
                    'SCHEDULETEMPLATE_READ',
                    'JOB_READ',
                    'CHECKPOINT_READ',
                    'SUPPLIER_VIEW',
                    'UNLOADINGAREA_READ',
                ],
                ['SUPPLIER_MANAGE', 'SUPPLIER_VIEW', 'CONTAINER_READ'],
                [
                    'USER_WRITE',
                    'USER_DELETE',
                    'USER_READ',
                    'ACTOR_WRITE',
                    'ACTOR_DELETE',
                    'ACTOR_READ',
                    'CHECKPOINT_READ',
                    'JOB_READ',
                    'CONTAINER_READ',
                    'SCHEDULETEMPLATE_READ',
                ],
                [
                    'BLC_READ',
                    'BLC_WRITE',
                    'BLC_REPORT_READ',
                    'VEHICLE_READ',
                    'VEHICLE_DELETE',
                    'VEHICLE_WRITE',
                    'ACTOR_WRITE',
                    'ACTOR_DELETE',
                    'ACTOR_READ',
                    'CHECKPOINT_READ',
                    'CONTAINER_READ',
                    'JOB_READ',
                    'SCHEDULETEMPLATE_DELETE',
                    'SCHEDULETEMPLATE_READ',
                    'SCHEDULETEMPLATE_WRITE',
                    'UNLOADINGAREA_GRANT',
                    'UNLOADINGAREA_READ',
                    'UNLOADINGAREA_WRITE',
                    'USER_WRITE',
                    'USER_DELETE',
                    'USER_READ',
                    'SUPPLIER_MANAGE',
                    'SUPPLIER_VIEW',
                    'UTIL_READ',
                ],
                [
                    'ACTOR_WRITE',
                    'ACTOR_READ',
                    'ACTOR_DELETE',
                    'UNLOADINGAREA_READ',
                    'CHECKPOINT_READ',
                    'SCHEDULETEMPLATE_READ',
                ],
                [
                    'CHECKPOINT_READ',
                    'CONTAINER_READ',
                    'UNLOADINGAREA_READ',
                    'UNLOADINGAREA_WRITE',
                ],
                [
                    'ACTOR_WRITE',
                    'ACTOR_DELETE',
                    'ACTOR_READ',
                    'CHECKPOINT_READ',
                    'CONTAINER_READ',
                    'JOB_READ',
                    'SCHEDULETEMPLATE_DELETE',
                    'SCHEDULETEMPLATE_READ',
                    'SCHEDULETEMPLATE_WRITE',
                    'UNLOADINGAREA_GRANT',
                    'UNLOADINGAREA_READ',
                    'USER_WRITE',
                    'USER_DELETE',
                    'USER_READ',
                    'SUPPLIER_MANAGE',
                    'SUPPLIER_VIEW',
                    'SUPER_USER',
                    'UTIL_READ',
                ],
                ['MOBILE_CALENDAR', 'STC_MOBILE_NOTIFICATIONS'],
            ],
            simplePermModels: [
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
            ],
            allowedUserGatesPerms: [
                'CHECKPOINT_READ',
                'CHECKPOINT_OPEN',
                'JOB_READ',
                'ACTOR_READ',
                'ACTOR_WRITE',
                'ACTOR_DELETE',
                'SCHEDULETEMPLATE_READ',
                'MOBILE_OPEN_DOOR',
            ],
            allowedUserAppPerms: [
                'CHECKPOINT_WRITE',
                'UNLOADINGAREA_READ',
                'APP_INTERNAL_STCMOBILE',
            ],
            defaultPermissions: ['USER_READ', 'CONTAINER_READ'],
            isOnlyOneContainerSelected: true,
            containsDisabledPermissions: false,
            activeContainerButtonToggleItem: null,
            isEditMode: false,
            isAllowedUserGatesSelected: false,
            isAnyContainerWithNoPermissions: [],
        }
    },
    async created() {
        // console.debug('[created] permissionsList', this.permissionsList)
        // console.debug(
        //     '[created] userPermissionList',
        //     this.$auth.user().Permissions
        // )

        this.isEditMode = false

        this.$nextTick(() => {
            $('.vue-treeselect__control').click()
        })

        // Reset/Clear existing permissions
        this.selectedContainers = []
        this.selectedContainers = [this.selectedContainer]

        let defaultCurrentContainer = {}
        defaultCurrentContainer.ContainerID = this.selectedContainer.ContainerID
        defaultCurrentContainer.Description = this.selectedContainer.Description
        defaultCurrentContainer.permissionsList = [...this.defaultPermissions]

        this.currentSelectedContainerList = []
        this.currentSelectedContainerList.push(defaultCurrentContainer)

        this.permissionSelectDoneObj.permissions = []

        // What happens next ?
        // 1.) We are getting all the (container-permission)s for the logged in user.
        // 2.) Check all the unique containers
        // 3.) Check all the sub containers under each of above containers.
        // 4.) Add the relevant permission to those containers
        // 5.) Assign it to  this.loggedInUserContainerWithPermissions

        // Now let's execute each above task.

        // 1.) We are getting all the (container-permission)s for the logged in user.
        const vals = this.$auth
            .user()
            .Permissions.map((container) => container.ContainerID)
        let loggedInUserContainerIdList = [...vals]

        // 2.) Check all the unique containers
        let loggedInUserUniqueContainerIdList = _.uniq(
            loggedInUserContainerIdList
        )

        let allEligibleContainerPermissionList = []
        const containerTreeTemp = _.cloneDeep(this.containerTree)
        const containerListCopy = _.cloneDeep(this.containers)

        // 3.) Check all the sub containers under each of above containers.
        // 4.) Add the relevant permission to those containers
        loggedInUserUniqueContainerIdList.forEach((parentContainerId) => {
            // So we have the parent container Id and we get all the permissions for this containerId
            let permList = []
            this.$auth.user().Permissions.forEach((perm) => {
                if (perm.ContainerID === parentContainerId) {
                    permList.push(perm.Permission)
                }
            })
            // make perm list unique. Because API returns duplicate permissions for same container id. API Bug!
            permList = _.uniq(permList)

            // Check uniqueness
            let objExists = allEligibleContainerPermissionList.filter(
                (e) => e.ContainerID === parentContainerId
            )

            if (objExists.length > 0) {
                let newPermList = []
                newPermList.push(...permList)
                newPermList.push(...objExists[0].permissionsList)
                newPermList = _.uniq(newPermList)

                // Okay we found this container in our final list
                // We need update/append the permissions
                objExists[0].permissionsList = newPermList

                // We need to find the sub containers as well under this container
                // If found  we need to update/append the permissions

                // We get all the sub container Ids
                let subContainerIdList = this.getProperty(
                    this.getObject(
                        containerTreeTemp,
                        'ContainerID',
                        parentContainerId
                    ),
                    'ContainerID'
                )

                // Add all the sun containers under this parent container with permission list
                subContainerIdList.forEach((subContainerId) => {
                    let subObjExists =
                        allEligibleContainerPermissionList.filter(
                            (e) => e.ContainerID === subContainerId
                        )
                    if (subObjExists.length > 0) {
                        // Found sub container in our final list
                        // We need update/append the permissions
                        let newPermList = []
                        newPermList.push(...permList)
                        newPermList.push(...subObjExists[0].permissionsList)
                        newPermList = _.uniq(newPermList)
                        subObjExists[0].permissionsList = newPermList
                    } else {
                        // Could not found the sub container in out final list
                        // Add all the sun containers under this parent container with permission list
                        subContainerIdList.forEach((subContainerId) => {
                            containerListCopy.forEach((subContainer) => {
                                if (
                                    subContainerId === subContainer.ContainerID
                                ) {
                                    subContainer.permissionsList = permList
                                    allEligibleContainerPermissionList.push(
                                        subContainer
                                    )
                                }
                            })
                        })
                    }
                })
            } else {
                // This is a new entry

                // Add the parent container with permission list
                containerListCopy.forEach((parentContainer) => {
                    if (parentContainerId === parentContainer.ContainerID) {
                        parentContainer.permissionsList = permList
                        allEligibleContainerPermissionList.push(parentContainer)
                    }
                })

                // We get all the sub container Ids
                let subContainerIdList = this.getProperty(
                    this.getObject(
                        containerTreeTemp,
                        'ContainerID',
                        parentContainerId
                    ),
                    'ContainerID'
                )
                // Add all the sun containers under this parent container with permission list
                subContainerIdList.forEach((subContainerId) => {
                    containerListCopy.forEach((subContainer) => {
                        if (subContainerId === subContainer.ContainerID) {
                            subContainer.permissionsList = permList
                            allEligibleContainerPermissionList.push(
                                subContainer
                            )
                        }
                    })
                })
            }
        })
        this.loggedInUserContainerWithPermissions = []
        this.loggedInUserContainerWithPermissions = [
            ...allEligibleContainerPermissionList,
        ]

        // Show disabled permission text
        let tempPermArr = []
        this.permissionsList.forEach((perm) => {
            tempPermArr.push(...perm.Values)
        })
        tempPermArr.forEach((perm) => {
            this.loggedInUserContainerWithPermissions.forEach((perm2) => {
                if (!perm2.permissionsList.includes(perm)) {
                    this.containsDisabledPermissions = true
                }
            })
        })

        // Select first container in the list by default
        this.showDefaultFirstContainer()

        Events.$on('user-editing', async (data) => {
            this.isEditMode = true
            //Reset values
            this.currentSelectedContainerList = []

            // User Edit Mode
            let containerPermissionDataReq = data.Permissions
            // console.log(
            //     '[Containers & Permissions]: [Edit Mode] Selected. Incoming containerPermissionDataReq: ',
            //     containerPermissionDataReq,
            // )

            /*
                Issue: If a user edits user details only, not permissions; then permissions apart from the first container are lost.
                Root Cause: When edit user window opens, the first container is selected by default,
                therefore permissions-select-done event is emitted from that first container losing permissions related to
                rest of the containers.
                Fix: Adding a timeout and sending all permissions via permissions-select-done event.
                */
            setTimeout(() => {
                this.$nextTick(() => {
                    let tempPermissionSelectDoneObj = []
                    tempPermissionSelectDoneObj.permissions =
                        containerPermissionDataReq
                    tempPermissionSelectDoneObj.unloadingAreas = []
                    Events.$emit(
                        'permissions-select-done',
                        tempPermissionSelectDoneObj
                    )
                })
            }, 2000)

            this.currentSelectedContainerList = await this.populatePermissions(
                containerPermissionDataReq
            )
            // console.log(
            //     '[Containers & Permissions]: [Edit Mode] Selected Container List: ',
            //     this.currentSelectedContainerList,
            // )
            this.selectedContainers = []
            this.selectedContainers = this.currentSelectedContainerList

            // Select first container in the list by default
            this.$nextTick(() => {
                this.showDefaultFirstContainer()
            })
        })

        // When Allow user access to gates? checkbox is clicked, add extra permissions to all the selected containers.
        Events.$on('ut-allow-gates', async (data) => {
            if (data) {
                this.isAllowedUserGatesSelected = true
                // Add permissions
                this.currentSelectedContainerList.forEach((container) => {
                    container.permissionsList.push(
                        ...this.allowedUserGatesPerms
                    )
                    container.permissionsList = _.uniq(
                        container.permissionsList
                    )
                })
            } else {
                // Remove permissions
                this.isAllowedUserGatesSelected = false
                this.currentSelectedContainerList.forEach((container) => {
                    if (container.permissionsList) {
                        let newArr = container.permissionsList.filter(
                            (item) => item !== 'CHECKPOINT_OPEN'
                        )
                        container.permissionsList = []
                        container.permissionsList.push(...newArr)
                        container.permissionsList = _.uniq(
                            container.permissionsList
                        )
                    }
                })
            }

            // console.log(this.currentSelectedContainerList)
            // console.log(this.currentSelectedContainer)
            this.selectAsCurrentContainerAndViewPermissions(
                this.currentSelectedContainer
            )
        })

        Events.$on('ut-allow-app', async (data) => {
            console.log('ut-allow-app', data)
            if (data) {
                this.isAllowedUserGatesSelected = true
                // Add permissions
                this.currentSelectedContainerList.forEach((container) => {
                    container.permissionsList.push(...this.allowedUserAppPerms)
                    container.permissionsList = _.uniq(
                        container.permissionsList
                    )
                })
            } else {
                // Remove permissions
                this.isAllowedUserGatesSelected = false
                this.currentSelectedContainerList.forEach((container) => {
                    if (container.permissionsList) {
                        let newArr = container.permissionsList.filter(
                            (item) => !this.allowedUserAppPerms.includes(item)
                        )
                        container.permissionsList = []
                        container.permissionsList.push(...newArr)
                        container.permissionsList = _.uniq(
                            container.permissionsList
                        )
                    }
                })
            }

            // console.log(this.currentSelectedContainerList)
            // console.log(this.currentSelectedContainer)
            this.selectAsCurrentContainerAndViewPermissions(
                this.currentSelectedContainer
            )
        })
    },
    beforeDestroy() {
        Events.$off('user-editing')
        Events.$off('ut-allow-gates')
        Events.$off('ut-allow-app')
        // Events.$off('add-container-from-user-create')
    },
    updated() {},
    mounted() {},
    components: {
        treeselect: Treeselect,
        'stc-dialog': StcDialog,
    },
    watch: {
        isAnyContainerWithNoPermissions: function (containers) {
            // console.log(containers)
            return containers.length === 0
                ? Events.$emit('show-hide-submit-button', true)
                : Events.$emit('show-hide-submit-button', false)
        },
        currentSelectedContainerList: function (containers) {
            Events.$emit('update-register-passings', containers)
            containers.length === 0
                ? Events.$emit('show-hide-submit-button', false)
                : Events.$emit('show-hide-submit-button', true)
        },
        // Toggle option action for Simple view & Detailed view
        showDetailedModeSelectedValue: function (val) {
            this.showDetailedMode = val === 'DETAILED_VIEW'
        },
        checkedPermissions: async function (val) {
            // console.log(
            //     '[detailed permissions] [checkedPermissions] val: ',
            //     val,
            // )
            // Show and hide submit button
            if (val.length === 0) {
                this.isAnyContainerWithNoPermissions.push(
                    this.currentSelectedContainer.ContainerID
                )
                // try {
                //     this.$alert(
                //         this.$i18n.i18next.t('message.warning.noPermissionsForContainer'),
                //         {
                //             confirmButtonText: 'OK',
                //         }
                //     )
                // } catch (e) {
                //     return false
                // }
            } else {
                this.isAnyContainerWithNoPermissions =
                    this.isAnyContainerWithNoPermissions.filter(
                        (item) =>
                            item !== this.currentSelectedContainer.ContainerID
                    )
            }
            val = _.uniq(val)

            if (
                !this.currentSelectedContainer ||
                !this.currentSelectedContainer.ContainerID
            ) {
                this.currentSelectedContainer =
                    this.currentSelectedContainerList[0]
            }
            let permissions = []
            val.forEach((permission) => {
                permissions.push({
                    ContainerID: this.currentSelectedContainer.ContainerID,
                    Permission: permission,
                })
            })
            // Remove existing permissions for this container from finalSelectedDetailedPermissionsList and set new permissions. val always provide selected values (both new and existing).
            if (
                this.finalSelectedDetailedPermissionsList &&
                this.finalSelectedDetailedPermissionsList.length > 0
            ) {
                this.finalSelectedDetailedPermissionsList =
                    this.finalSelectedDetailedPermissionsList.filter(
                        (item) =>
                            item.ContainerID !==
                            this.currentSelectedContainer.ContainerID
                    )
            }
            // console.log(permissions)
            this.finalSelectedDetailedPermissionsList.push(...permissions)
            this.permissionSelectDoneObj.permissions =
                this.finalSelectedDetailedPermissionsList

            // Update current container
            this.currentSelectedContainerList.forEach((container) => {
                if (
                    val &&
                    val.length > 0 &&
                    container.ContainerID ===
                        this.currentSelectedContainer.ContainerID
                ) {
                    // Updating the currentSelectedContainerList and currentSelectedContainer
                    container.permissionsList = []
                    container.permissionsList.push(...val)
                    container.permissionsList = _.uniq(
                        container.permissionsList
                    )
                    this.currentSelectedContainer.permissionsList =
                        container.permissionsList
                }
            })

            // Send updated permissions
            let permissionSelectDoneTemp = new Object()
            permissionSelectDoneTemp.permissions = []
            permissionSelectDoneTemp.unloadingAreas = []

            this.currentSelectedContainerList.forEach((container) => {
                container.permissionsList.forEach((perm) => {
                    let obj = new Object()
                    obj.ContainerID = container.ContainerID
                    obj.Permission = perm
                    permissionSelectDoneTemp.permissions.push(obj)
                })
            })
            Events.$emit('permissions-select-done', permissionSelectDoneTemp)
        },
    },
    computed: {
        ...mapGetters(['selectedContainer', 'containerTree']),
        selectedContainerTree() {
            // return [this.container]
            return this.containerTree
        },
        // Check difference between simple permissions and all permissions
        diffPermList() {
            let sl = this.getUniqueListFromSimplePermList()
            let dl = this.getUniqueListFromDetailedPermissionList()
            return _.difference(dl, sl)
        },
    },
    methods: {
        // If by default, first container of the current selected containers (with permissions) needs to selected, use this method.
        showDefaultFirstContainer() {
            if (
                this.currentSelectedContainerList &&
                this.currentSelectedContainerList.length > 0
            ) {
                this.currentSelectedContainer =
                    this.currentSelectedContainerList[0]
                this.selectAsCurrentContainerAndViewPermissions(
                    this.currentSelectedContainer
                )
            }
        },
        showPermissionsSelectContainerList() {
            this.showContainerTreeSelect = !this.showContainerTreeSelect
            // Expand container tree select in add container popup
            this.$nextTick(() => {
                this.setExpandLevel(3)
            })
        },
        setExpandLevel(level) {
            const { containerTreeSelect } = this.$refs
            containerTreeSelect.traverseAllNodes((node) => {
                if (node.isBranch) {
                    // note that `level` is zero-based
                    node.isExpanded = node.level <= level
                }
            })
        },
        getObject(array, key, value) {
            let o
            array.some(function iter(a) {
                if (a[key] === value) {
                    o = a
                    return true
                }
                return Array.isArray(a.Children) && a.Children.some(iter)
            })
            return o
        },
        getProperty(object, key) {
            function iter(a) {
                let item = this ? this[a] : a
                if (this && a === key) {
                    return result.push(item)
                }
                if (Array.isArray(item)) {
                    return item.forEach(iter)
                }
                if (item !== null && typeof item === 'object') {
                    return Object.keys(item).forEach(iter, item)
                }
            }

            let result = []
            Object.keys(object).forEach(iter, object)
            return result
        },
        async populatePermissions(data) {
            // We are getting all the (container-permission) list.
            // Get all the container id list.
            let containerIdList = [
                ...data.map((container) => container.ContainerID),
            ]

            // Filter for unique ids
            let uniqueContainerIdList = containerIdList.filter(function (
                item,
                index
            ) {
                if (containerIdList.indexOf(item) == index) return item
            })

            // Populate containers for the above unique ids
            let containersForTheUser = []
            let containersTemp = [...this.containers]

            uniqueContainerIdList.forEach((id) => {
                containersTemp.forEach((container) => {
                    if (container.ContainerID === id) {
                        containersForTheUser.push(container)
                    }
                })
            })

            // Add permissions to each container
            containersForTheUser.forEach((container) => {
                container.permissionsList = []
                data.forEach((perm) => {
                    if (perm.ContainerID === container.ContainerID) {
                        container.permissionsList.push(perm.Permission)
                    }
                })
            })

            return containersForTheUser
        },
        async deleteContainer(container, index) {
            try {
                console.debug(
                    '[deleteContainer]: container to be deleted: ',
                    container.Description,
                    container.ContainerID,
                    index
                )

                // Once delete X button selected, make sure this container is showed with permissions.
                // this.activeContainerButtonToggleItem = index
                this.selectAsCurrentContainerAndViewPermissions(container)

                await this.$confirm(
                    this.$t('message.warning.deleteContainer'),
                    this.$t('button.text.delete') + ' ' + container.Description,
                    {
                        confirmButtonText: this.$i18n.i18next.t(
                            'button.text.confirm'
                        ),
                        cancelButtonText:
                            this.$i18n.i18next.t('button.text.cancel'),
                        type: 'warning',
                    }
                )
                // console.debug(
                //     '[deleteContainer]: selectedContainers: ',
                //     this.currentSelectedContainerList,
                // )
                // Remove container permissions from finalSelectedDetailedPermissionsList
                if (
                    this.finalSelectedDetailedPermissionsList &&
                    this.finalSelectedDetailedPermissionsList.length > 0
                ) {
                    this.finalSelectedDetailedPermissionsList =
                        this.finalSelectedDetailedPermissionsList.filter(
                            (item) => item.ContainerID !== container.ContainerID
                        )
                }

                // Remove from currentSelectedContainerList
                this.currentSelectedContainerList =
                    this.currentSelectedContainerList.filter(
                        (i) => i.ContainerID !== container.ContainerID
                    )

                // Remove from selectedContainers
                this.selectedContainers = this.selectedContainers.filter(
                    (i) => i.ContainerID !== container.ContainerID
                )

                // console.log(
                //     'Permissions after deleting the container ',
                //     this.finalSelectedDetailedPermissionsList,
                //     sc1
                // )
                this.permissionSelectDoneObj.permissions =
                    this.finalSelectedDetailedPermissionsList
                Events.$emit(
                    'permissions-select-done',
                    this.permissionSelectDoneObj
                )
                this.$forceUpdate()

                // Select first container in the list by default
                this.showDefaultFirstContainer()

                return true
            } catch (e) {
                return false
            }
        },
        save() {
            let obj = {
                showContainerAndPermissions: false,
                data: null,
            }
            Events.$emit('show-containers-permissions', obj)
            Events.$emit('show-create-or-edit-view', false)
        },
        selectAsCurrentContainerAndViewPermissions(clickedContainer) {
            // console.log('clickedContainer', clickedContainer, this.simplePermissions, this.checkedPermissions)
            this.currentSelectedContainer = clickedContainer

            this.resetCurrentValues()

            if (clickedContainer && clickedContainer.permissionsList) {
                // Show permissions on detailed view
                clickedContainer.permissionsList.forEach((val) => {
                    this.checkedPermissions.push(val)
                })
                // Show permissions on simple view
                this.simplePermConstArr.forEach((arr) => {
                    if (
                        arr
                            .split(',')
                            .every((i) => this.checkedPermissions.includes(i))
                    ) {
                        this.simplePermissions.push(arr)
                    }
                })
            }

            this.loggedInUserContainerWithPermissions.forEach((lc) => {
                if (lc.ContainerID === clickedContainer.ContainerID) {
                    this.loggedInUserContainerPermissionsForCurrentMatch =
                        lc.permissionsList
                    this.isOnlyOneContainerSelected = false
                    this.$nextTick(() => {
                        this.$forceUpdate()
                    })
                }
            })

            this.$nextTick(() => {
                // Update simplePermModels
                this.updateSimplePermModels()
            })
        },
        resetCurrentValues() {
            this.checkedPermissions = []
            this.simplePermissions = []
            this.simplePermModels = [
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
            ]
        },
        changeIncludeSubContainers() {
            if (this.includeSubContainers) {
                this.selectedContainers = null
                setTimeout(
                    function () {
                        this.isFlat = false
                    }.bind(this),
                    1000
                )
            } else {
                this.selectedContainers = null
                setTimeout(
                    function () {
                        this.isFlat = true
                    }.bind(this),
                    1000
                )
            }
        },
        async handleBeforeClearAll() {
            try {
                await this.$confirm(
                    'Are you sure you want clear the fields?',
                    'Warning',
                    {
                        confirmButtonText: this.$i18n.i18next.t(
                            'button.text.confirm'
                        ),
                        cancelButtonText:
                            this.$i18n.i18next.t('button.text.cancel'),
                        type: 'warning',
                    }
                )
                return true
            } catch (e) {
                return false
            }
        },
        // If there are existing permissions, then toggle the v-expansion-panel
        permissionsToggleHandling(permission, checkedPermissions) {
            return permission.Values.some((ai) =>
                checkedPermissions.includes(ai)
            )
        },
        getUniqueListFromSimplePermList() {
            let output = []
            this.simplePermConstArr2.forEach((val) => output.push(...val))
            return _.uniq(output)
        },
        getUniqueListFromDetailedPermissionList() {
            let output = []
            this.permissionsList.forEach((perm) => {
                output.push(...perm.Values)
            })
            return _.uniq(output)
        },
        onContainerSelect() {
            // Hide Add Container Popup
            this.showContainerTreeSelect = false
            // Add or Remove Containers to currentSelectedContainerList

            let newContainerList = []

            this.selectedContainers.forEach((container) => {
                let newContainer = {}
                newContainer.ContainerID = container.ContainerID
                newContainer.Description = container.Description
                newContainer.ContainerType = container.ContainerType
                newContainer.permissionsList = [...this.defaultPermissions]
                if (this.isAllowedUserGatesSelected) {
                    newContainer.permissionsList.push(
                        ...this.allowedUserGatesPerms
                    )
                }
                newContainerList.push(newContainer)
            })

            this.currentSelectedContainerList.forEach((currentContainer) => {
                newContainerList.forEach((newCon) => {
                    if (currentContainer.ContainerID === newCon.ContainerID) {
                        newCon.permissionsList =
                            currentContainer.permissionsList
                    }
                })
            })

            this.currentSelectedContainerList = []
            this.currentSelectedContainerList = newContainerList

            let permissionSelectDoneTemp = new Object()
            permissionSelectDoneTemp.permissions = []
            permissionSelectDoneTemp.unloadingAreas = []

            let isCurrentSelectedContainerFound = false

            newContainerList.forEach((con) => {
                // Build permissionSelect to silently push updated container-permissions
                con.permissionsList.forEach((perm) => {
                    let obj = new Object()
                    obj.ContainerID = con.ContainerID
                    obj.Permission = perm
                    permissionSelectDoneTemp.permissions.push(obj)
                })

                if (
                    this.currentSelectedContainer &&
                    this.currentSelectedContainer.ContainerID ===
                        con.ContainerID
                ) {
                    isCurrentSelectedContainerFound = true
                }
            })

            // Render checkboxes UI with latest permissions
            if (isCurrentSelectedContainerFound) {
                this.$nextTick(() => {
                    this.selectAsCurrentContainerAndViewPermissions(
                        this.currentSelectedContainer
                    )
                })
            } else {
                if (newContainerList && newContainerList.length > 0) {
                    this.$nextTick(() => {
                        this.selectAsCurrentContainerAndViewPermissions(
                            newContainerList[0]
                        )
                    })
                }
            }

            // Update final container permissions list
            // setTimeout(() => {
            //     this.$nextTick(()=>{
            //         Events.$emit(
            //             'permissions-select-done',
            //             permissionSelectDoneTemp,
            //         )
            //     })
            // } , 2000)
        },
        onSimplePermChange(val1, val2) {
            // console.log(val1, val2)
            let permList = this.getUniquePermissionsFromStrHelper(val2)
            // console.log('[onSimplePermChange] before checkedList', this.checkedPermissions)
            if (val1 === 'true') {
                // Add permissions
                // Need to add permList
                if (this.simplePermissions.indexOf(val2) === -1) {
                    this.simplePermissions.push(val2)
                }

                this.checkedPermissions.push(...permList)
                this.checkedPermissions = _.uniq(this.checkedPermissions)
            } else {
                // Remove permissions
                // Need to remove permList
                this.simplePermissions = this.removeFromListHelper(
                    this.simplePermissions,
                    val2
                )

                // Remove from checkedPermissions
                this.checkedPermissions = this.checkedPermissions.filter(
                    function (el) {
                        return permList.indexOf(el) < 0
                    }
                )
                this.checkedPermissions = _.uniq(this.checkedPermissions)

                // Handle duplicate permissions in simple view
                let currentSimplePerms =
                    this.getUniquePermissionsFromListHelper(
                        this.simplePermissions
                    )
                currentSimplePerms.forEach((perm) => {
                    if (!this.checkedPermissions.includes(perm)) {
                        this.checkedPermissions.push(perm)
                        this.checkedPermissions = _.uniq(
                            this.checkedPermissions
                        )
                    }
                })
            }
            // console.log('[onSimplePermChange] simplePermissions ', this.simplePermissions)
            // console.log('[onSimplePermChange] after checkedList', this.checkedPermissions)
            this.updateCurrentContainer(this.checkedPermissions)
        },
        getUniquePermissionsFromStrHelper(val) {
            let actions = val.split(',')
            return _.uniq(actions)
        },
        getUniquePermissionsFromListHelper(val) {
            let actionList = []
            val.forEach((action) => {
                let actions = action.split(',')

                actions.forEach((action) => {
                    actionList.push(action)
                })
            })
            actionList = _.uniq(actionList)
            return actionList
        },
        removeFromListHelper(arr, val) {
            let idx = arr.indexOf(val)
            if (idx !== -1) {
                arr.splice(idx, 1)
            }
            return arr
        },
        onDetailedPermChange(val1, val2) {
            // console.log(val1, val2, this.checkedPermissions)
            if (val1.includes(val2)) {
                // Permissions added
                this.updateSimplePermModels()
            } else {
                //Permission removed
                // Check simple permissions and remove if exists
                let simplePermissionsTemp = _.cloneDeep(this.simplePermissions)
                simplePermissionsTemp.forEach((permSet) => {
                    let permList =
                        this.getUniquePermissionsFromStrHelper(permSet)
                    if (permList.includes(val2)) {
                        let idx = this.simplePermissions.indexOf(permSet)
                        if (idx !== -1) {
                            this.simplePermissions.splice(idx, 1)
                        }
                        let index = this.simplePermConstArr.indexOf(permSet)
                        this.simplePermModels[index] = 'false'
                    }
                })
                // console.log('[onDetailedPermChange] this.simplePermissions', this.simplePermissions)
            }

            this.updateCurrentContainer(this.checkedPermissions)
        },
        updateSimplePermModels() {
            this.simplePermConstArr2.forEach((permSet, index) => {
                if (
                    this.checkedPermissions.filter(
                        (e) => permSet.indexOf(e) !== -1
                    ).length === permSet.length
                ) {
                    this.simplePermModels[index] = 'true'
                }
            })
        },
        updateCurrentContainer(val) {
            this.currentSelectedContainerList.forEach((container) => {
                if (
                    container.ContainerID ===
                    this.currentSelectedContainer.ContainerID
                ) {
                    this.currentSelectedContainer.ContainerType =
                        container.ContainerType
                    // Updating the currentSelectedContainerList and currentSelectedContainer
                    container.permissionsList = []
                    container.permissionsList.push(...val)
                    container.permissionsList = _.uniq(
                        container.permissionsList
                    )
                    this.currentSelectedContainer.permissionsList =
                        container.permissionsList
                }
            })
        },

        disbaledDetailedModePermissions(permission) {
            const isSystemAdmin =
                this.loggedInUserContainerPermissionsForCurrentMatch.includes(
                    'SYSTEM_ADMIN'
                )
            const isCurrentContainerCCC =
                this.currentSelectedContainer.ContainerType === 'CCC'
            const isSelfCheckinPermission = permission === 'SELF_CHECKIN'
            if (
                isSystemAdmin &&
                isSelfCheckinPermission &&
                isCurrentContainerCCC
            ) {
                return false
            }
            const permissions = _.cloneDeep(
                this.loggedInUserContainerPermissionsForCurrentMatch
            )
            const index = permissions.indexOf('SELF_CHECKIN')
            if (index > -1) {
                permissions.splice(index, 1)
            }
            return !permissions.includes(permission)
        },
    },
}
</script>
<style scoped>
.vue-treeselect__value-remove {
    display: none !important;
}

.container-btn-toggle {
    width: auto !important;
    margin: 1px !important;
}

.el-dialog__body {
    height: 400px !important;
}

.theme--light
    .expansion-panel
    .expansion-panel__container
    .expansion-panel__header
    .icon {
    color: white !important;
}
</style>
<style>
.theme--light
    .expansion-panel
    .expansion-panel__container
    .expansion-panel__header
    .icon {
    color: white !important;
}

.input-group:not(.input-group--error).input-group--disabled label {
    color: #989ea69e !important;
}

.theme--light .input-group:not(.input-group--error) label {
    color: #b4bac2;
}

.v-modal {
    z-index: 0 !important;
}
</style>
